import Box from "@material-ui/core/esm/Box";
import Button from "@material-ui/core/esm/Button";
import Icon from "@material-ui/core/esm/Icon";
import GetAppOutlined from "@material-ui/icons/esm/GetAppOutlined";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from 'components/Spinner/Spinner';
import useStyles from './ButtonStyles';
export default function Download({
  onClick,
  children,
  loading,
  disabled
}) {
  const {
    t
  } = useTranslation();
  const {
    download,
    wrapper
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: wrapper
  }, /*#__PURE__*/React.createElement(Button, {
    className: download,
    onClick: onClick,
    disabled: loading || disabled
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2,
    mt: 1
  }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(GetAppOutlined, {
    color: "primary"
  }))), /*#__PURE__*/React.createElement("span", null, children || t('buttons.download'))), loading && /*#__PURE__*/React.createElement(Spinner, {
    isButtonProgress: true
  }));
}
Download.defaultProps = {
  disabled: false,
  loading: false,
  children: ''
};